import { isArray } from 'lodash';
import moment from 'moment';
import validUrl from 'valid-url';
import { EDITOR_EMTPY_TEXT } from '../components/TextEditor';
import {
  FLEX_ACTION_TYPE,
  MAX_FLEX_LIMIT,
} from '../constants/abuddy.constants';
import { KEYBOARD_KEYS, regexForScore } from '../constants/assessment.constants';

export const isStringUrl = (url) => {
  return validUrl.isHttpsUri(url);
};

export const getDateFormat = (date) => {
  return moment(date).format('MMMM DD YYYY HH:mm:ss');
};

export const isFlexActionText = (actionType) => {
  return (
    actionType === FLEX_ACTION_TYPE.TEXT ||
    actionType === FLEX_ACTION_TYPE.LINK_OUT ||
    actionType === FLEX_ACTION_TYPE.LINK_CONTENT ||
    actionType === FLEX_ACTION_TYPE.TEXT_BY_USER
  );
};

export const isFlexLinkContent = (actionType) => {
  return actionType === FLEX_ACTION_TYPE.LINK_CONTENT;
};

export const isFlexActionUrl = (actionType) => {
  return (
    actionType === FLEX_ACTION_TYPE.LINK_OUT ||
    actionType === FLEX_ACTION_TYPE.LINK_CONTENT
  );
};

export const displayLabelActionDetail = (actionType) => {
  if (
    actionType === FLEX_ACTION_TYPE.TEXT ||
    actionType === FLEX_ACTION_TYPE.TEXT_BY_USER
  ) {
    return 'Message';
  }
  if (actionType === FLEX_ACTION_TYPE.LINK_OUT) {
    return 'URL';
  }
  if (actionType === FLEX_ACTION_TYPE.LINK_CONTENT) {
    return 'Content URL';
  }
};

export const isTypeNoAction = (actionType) => {
  const isNoAction =
    actionType === FLEX_ACTION_TYPE.NO_ACTION ||
    actionType === FLEX_ACTION_TYPE.ACTIVATE;
  return isNoAction;
};

export const notDisplayLabel = (actionType) => {
  const isNoAction =
    actionType === FLEX_ACTION_TYPE.NO_ACTION ||
    actionType === FLEX_ACTION_TYPE.TEXT_BY_USER ||
    actionType === FLEX_ACTION_TYPE.ACTIVATE ||
    actionType === FLEX_ACTION_TYPE.AHAPPY;
  return isNoAction;
};

export const getSubCategories = (actionDetail) => {
  if (isArray(actionDetail)) {
    return actionDetail.length !== 0 ? actionDetail : [];
  }
  return [];
};

export const getContents = (actionDetail) => {
  if (isArray(actionDetail)) {
    return actionDetail.length !== 0 ? actionDetail : [];
  }
  return [];
};

export const isDefaultActionType = (actionType) => {
  return (
    actionType === FLEX_ACTION_TYPE.MY_LIST ||
    actionType === FLEX_ACTION_TYPE.REGISTER ||
    actionType === FLEX_ACTION_TYPE.ACTIVATE ||
    actionType === FLEX_ACTION_TYPE.LIST_SHOP ||
    actionType === FLEX_ACTION_TYPE.AHAPPY ||
    actionType === FLEX_ACTION_TYPE.LIBRARY
  );
};

export const isEditorEmptyText = (content) => {
  return content === EDITOR_EMTPY_TEXT;
};

export const isFlexOverLimit = (length) => {
  return length > MAX_FLEX_LIMIT;
};

export const getAssesmentDateFormat = (date) => {
  return date ? moment(date).format("YYYY-MM-DD HH:mm:ss") : '-';
};

export const preventInvalidInput = (e) => {
  const allowedKeys = [KEYBOARD_KEYS.backspace, KEYBOARD_KEYS.arrowLeft,
  KEYBOARD_KEYS.arrowRight, KEYBOARD_KEYS.delete, KEYBOARD_KEYS.tab];
  if (allowedKeys.includes(e.key)) {
    return;
  }
  if (!regexForScore.test(e.key)) {
    e.preventDefault();
  }
}

export const isEmpty = (value) => {
  const type = typeof value;
  if (value !== null && type === 'object') {
    const prototype = Object.getPrototypeOf(value) || {};
    const properties = Object.keys(value) + Object.keys(prototype);
    return properties.length === 0 || properties.size === 0
  } else if (type === 'function') {
    const res = value();
    return isEmpty(res);
  }
  return !value;
}

export const commaFormatNumber = (value) => value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

export const getChatbotDateFormat = (date) => {
  return date ? moment.utc(date).utcOffset(420).format("YYYY-MM-DD HH:mm:ss") : '-';
}